export type TooltipPlacement = 'top' | 'bottom';

export interface TooltipPosition {
    left: number;
    top: number;
    placement: TooltipPlacement;
}

interface RectSize {
    left: number;
    top: number;
    width: number;
    height: number;
}

const TOOLTIP_GAP_PX = 8;
const VIEWPORT_EDGE_MARGIN_PX = 8;

function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), Math.max(min, max));
}

/**
 * 提示固定定位在視窗座標：預設放在元件上方，上方放不下（例如表格第一列）就翻到下方，
 * 水平方向夾在視窗內。不依賴任何祖先的 overflow 或 z-index，才不會被表頭蓋住或被捲動區裁掉。
 */
export function computeTooltipPosition(
    anchor: RectSize,
    bubble: Pick<RectSize, 'width' | 'height'>,
    viewportWidth: number
): TooltipPosition {
    const fitsAbove = anchor.top - bubble.height - TOOLTIP_GAP_PX >= VIEWPORT_EDGE_MARGIN_PX;
    const placement: TooltipPlacement = fitsAbove ? 'top' : 'bottom';
    const top = fitsAbove
        ? anchor.top - bubble.height - TOOLTIP_GAP_PX
        : anchor.top + anchor.height + TOOLTIP_GAP_PX;
    const centeredLeft = anchor.left + anchor.width / 2 - bubble.width / 2;
    const left = clamp(
        centeredLeft,
        VIEWPORT_EDGE_MARGIN_PX,
        viewportWidth - bubble.width - VIEWPORT_EDGE_MARGIN_PX
    );
    return { left, top, placement };
}
